<script setup>
import {
  NavigationMenu,
  NavigationMenuContent,
  NavigationMenuItem,
  NavigationMenuLink,
  NavigationMenuList,
  NavigationMenuTrigger,
} from "@/components/ui/navigation-menu"
import {computed} from "vue";

const props = defineProps({
  availableLocales: {
    type: Array,
    required: true,
  },
  selectedLocale: {
    type: String,
    required: true,
  },
});

const emit = defineEmits(['locale-changed']);

const currentLocaleLabel = computed(() => {
  const current = props.availableLocales.find(l => l.key === props.selectedLocale);
  const label = current ? current.label : props.selectedLocale;
  return label.toUpperCase();
});

const handleLocaleSwitch = (localeKey) => {
  emit('locale-changed', localeKey);
};
</script>

<template>
  <div class="mobile-locale-switcher">
    <NavigationMenu>
      <NavigationMenuList>
        <NavigationMenuItem>
          <NavigationMenuTrigger>
            <span style="color: #3B82F6;">
              {{ currentLocaleLabel }}
            </span>
          </NavigationMenuTrigger>

          <NavigationMenuContent>
            <ul class="flex flex-col w-[100px] p-2">
              <li v-for="locale in availableLocales" :key="`mobile-locale-${locale.key}`">
                <NavigationMenuLink
                    as-child
                    @click="handleLocaleSwitch(locale.key)"
                >
                  <a
                      :class="{
                      'font-bold text-blue-600 bg-gray-100': selectedLocale === locale.key,
                      'text-gray-700': selectedLocale !== locale.key,
                    }"
                  >
                    {{ locale.label.toUpperCase() }}
                  </a>
                </NavigationMenuLink>
              </li>
            </ul>
          </NavigationMenuContent>
        </NavigationMenuItem>
      </NavigationMenuList>
    </NavigationMenu>
  </div>
</template>

<style scoped>
/* Дополнительные мобильные стили, если требуются */
</style>